export default __webpack_public_path__ + "static/media/mobile-0819.063578d5.jpg";